var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"backgroundImage",attrs:{"dark":""}},[_c('nav-bar'),_c('transition',{attrs:{"name":_vm.$route.name,"mode":"out-in"}},[_c('router-view')],1),_c('foooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }